const getByPath = (obj, path) =>
  path.split('.').reduce((acc, key) => (acc ? acc[key] : undefined), obj);

const isPlainObject = (value) =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const normalizeValue = (value) => {
  if (isPlainObject(value)) {
    try {
      return JSON.stringify(value);
    } catch (error) {
      return value;
    }
  }
  return value;
};

export const getSelectedElements = (elements, selectedIds) =>
  elements.filter((element) => selectedIds.includes(element.id));

export const getSelectionType = (selectedElements) => {
  if (!selectedElements.length) return 'none';
  const types = new Set(selectedElements.map((el) => el.type));
  if (types.size === 1) {
    const type = [...types][0];
    if (type === 'text' || type === 'image' || type === 'shape' || type === 'frame') return type;
    return 'mixed';
  }
  return 'mixed';
};

export const getMixedValue = (selectedElements, path) => {
  if (!selectedElements.length) {
    return { kind: 'mixed' };
  }
  const first = getByPath(selectedElements[0], path);
  const firstNormalized = normalizeValue(first);
  const isSame = selectedElements.every((el) => (
    normalizeValue(getByPath(el, path)) === firstNormalized
  ));
  if (isSame) {
    return { kind: 'single', value: first };
  }
  return { kind: 'mixed' };
};

export const getLockedState = (selectedElements) => {
  const lockedValues = selectedElements.map((el) => Boolean(el.locked));
  const allLocked = lockedValues.every((locked) => locked);
  const anyLocked = lockedValues.some((locked) => locked);
  return {
    allLocked,
    anyLocked,
    mixed: anyLocked && !allLocked,
  };
};
